import { IconProps } from 'src/utils/icon';

const SignOutIcon: React.FC<IconProps> = ({ size = 1 }) => (
  <svg
    style={{ fontSize: `${size}rem` }}
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 14 14"
  >
    <path
      fill="#2c2a29"
      d="M13.806 6.171L9.14 11.01c-.416.432-1.139.13-1.139-.49V7.756H4.222a.678.678 0 01-.666-.69V4.3c0-.383.297-.691.666-.691H8V.844c0-.616.72-.921 1.14-.49l4.666 4.838a.715.715 0 010 .98zm-8.472 4.694V9.713A.34.34 0 005 9.368H2.667c-.492 0-.89-.412-.89-.922V2.917c0-.51.398-.921.89-.921H5a.34.34 0 00.334-.346V.5A.34.34 0 005 .153H2.667C1.195.153 0 1.391 0 2.917v5.53c0 1.526 1.194 2.764 2.667 2.764H5a.34.34 0 00.334-.346z"
    />
  </svg>
);

export default SignOutIcon;
